import React, { useEffect, useRef, useState } from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import PageSection from '../PageSections/PageSection';
import * as styles from './LogosHeader.module.scss';

export default function LogosHeader({ section }) {
  const logosRef = useRef();
  const [renderLogos, setRenderLogos] = useState(false);

  const handleResize = () => {
    if (logosRef.current) {
      logosRef.current.style.setProperty('--containerHeight', `${logosRef.current.clientHeight}px`);
    }
  };

  useEffect(() => {
    if (logosRef.current) {
      setRenderLogos(true);
      logosRef.current.style.setProperty('--containerHeight', `${logosRef.current.clientHeight}px`);
    }
  }, [section.logos, logosRef]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <PageSection
      isTopSection
      wide
      slim
      className={styles[section.backgroundColor]}
      innerClassName={styles.logosHeader}
      style={{ paddingBlock: 0 }}
      data-analytics-section={'logos-header'}
    >
      <div className={styles.copy}>
        {section.headingSuper && <span className={styles.headingSuper}>{section.headingSuper}</span>}
        {section.heading && <h1>{section.heading}</h1>}
        {section.headingIntroCopy && <RichTextConverter copy={section.headingIntroCopy} />}
      </div>
      <div className={styles.image}>
        <ContentfulImage imageFragment={section.headingImage} />
        <div ref={logosRef} className={styles.logos}>
          {renderLogos &&
            section.logos?.media?.map((logo, i) => {
              return (
                <ContentfulImage
                  imageFragment={logo}
                  key={i}
                  className={styles.logo}
                  style={{ '--delay': `${-i * (20 / section.logos.media.length)}s` }}
                  data-analytics-component={'customer-logos'}
                  data-analytics-id={logo.title}
                />
              );
            })}
        </div>
      </div>
    </PageSection>
  );
}
